import React, { useEffect, useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import _, { round, trim } from 'lodash'
import moment from 'moment'
import {
  Div, H4, P, InputWithLabel, Loading, DynamicButtonLink,
} from 'konsys-ui'
import { Radio, DatePicker, Select } from 'antd'
import { theme } from '../../../styles/_variables'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { GET_JOB, CHECK_PRICE, RECOMMEND_AVAILABLE_ORDER } from '../../../constants/graphql/query'
import { CREATE_JOB, UPDATE_JOB } from '../../../constants/graphql/mutation'
import { MYINFO } from '../../../constants/graph/query'
import { CustomerJobDetail } from './customerDetail'
import { ActionBar } from '../../../components/job-components'
import PERMISSION from '../../../constants/permissions'
import ROLE from '../../../constants/role'

const { color } = theme

const Index = ({ props }) => {
  const {
    data: myInfo, loading: myInfoLoading,
  } = useQuery(MYINFO)
  if (myInfoLoading || _.isEmpty(myInfo)) return <Loading center='true' />
  if (myInfo.myInfo.Roles[0].id === ROLE.CUSTOMER.id) return <CustomerJobDetail props={props} />
  return (
    <Detail props={props} />
  )
}

const Detail = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  const [mutationVariables, setMutationVariables] = useState(
    isAddMode ? {
      dealType: 'PERWEIGHT',
      contractStart: moment().format('YYYY-MM-DD'),
      contractEnd: moment().format('YYYY-MM-DD'),
      availableOrder: undefined,
    } : {},
  )

  const jobData = useQuery(GET_JOB, {
    variables: { id: props.match.params.id },
    skip: isAddMode,
  })

  useEffect(() => {
    if (!_.isUndefined(mutationVariables.availableOrder) || isAddMode) {
      if (mutationVariables.dealType === 'PERTRIP' && mutationVariables.contractWeight) {
        setMutationVariables({ ...mutationVariables, availableOrder: mutationVariables.contractWeight, remainingOrder: !isAddMode ? mutationVariables.contractWeight - mutationVariables.shippings : undefined })
      } else if (trim(mutationVariables.cargo) === 'โมลาส' && mutationVariables.unit === 'TON' && mutationVariables.dealType === 'PERWEIGHT' && mutationVariables.average) {
        setMutationVariables({ ...mutationVariables, availableOrder: round(mutationVariables.contractWeight / mutationVariables.average), remainingOrder: !isAddMode ? round(mutationVariables.contractWeight / mutationVariables.average) - mutationVariables.shippings : undefined })
      } else {
        setMutationVariables({ ...mutationVariables, availableOrder: null })
      }
    }
  }, [mutationVariables.cargo, mutationVariables.unit, mutationVariables.dealType, mutationVariables.contractWeight, mutationVariables.average])

  const [clientInfo, setClientInfo] = useState({})
  const [dealType, setDealType] = useState()

  let onChangeHandler = (id, value) => {
    const parseValue = (id === 'contractWeight')
    ? _.toSafeInteger(value)
    : _.includes(['predealPrice', 'feeRate', 'average'], id)
      ? parseFloat(value)
      : value
    // const parseValue = (id === 'contractWeight')
    //   ? (_.isEmpty(value) ? 0 : parseInt(value, 10))
    //   : id === 'feeRate' || id === 'predealPrice'
    //     ? parseFloat(value)
    //     : value
    if (id === 'dealType') {
      setMutationVariables({
        ...mutationVariables,
        [id]: parseValue,
        unit: null, // TODO
        isLocationChanges: _.includes(['startDestination', 'endDestination'], id),
      })
      setDealType(parseValue)
    } else {
      setMutationVariables({
        ...mutationVariables,
        [id]: parseValue,
        isLocationChanges: _.includes(['startDestination', 'endDestination'], id),
      })
    }
  }

  const setClientHandler = (obj) => {
    setClientInfo({
      ...clientInfo,
      ...obj,
    })
  }
  return (
    <Div display='flex' flexDirection='column'>
    {
      isAddMode
        ? <Query
            query={CHECK_PRICE}
            variables={{ startDestination: mutationVariables.startDestination, endDestination: mutationVariables.endDestination }}
            skip={_.isUndefined(mutationVariables.startDestination) || _.isUndefined(mutationVariables.endDestination)}
            // fetchPolicy='network-only'
          >{({ data, error, loading }) => {
            if (
              data
              && !loading
              && !error
              && (
                mutationVariables.feeRate !== data.searchLastestInputFromLocation.jobInfo.feeRate
                || mutationVariables.distance !== data.searchLastestInputFromLocation.jobInfo.distance
              )
              && mutationVariables.isLocationChanges
            ) {
              setMutationVariables({
                ...mutationVariables,
                feeRate: data.searchLastestInputFromLocation.jobInfo.feeRate,
                distance: data.searchLastestInputFromLocation.jobInfo.distance,
              })
            }
            return (
              <DetailContainer
                loadingLastPrice={loading}
                mode={{ isAddMode, isViewMode }}
                props={props}
                onChangeHandler={onChangeHandler}
                client={{ clientInfo, setClientHandler }}
                mutationVariables={mutationVariables}
                dealType={dealType}
              />
            )
          }}</Query>
        : <Query
            query={CHECK_PRICE}
            variables={{ startDestination: mutationVariables.startDestination, endDestination: mutationVariables.endDestination }}
            skip={_.isUndefined(mutationVariables.startDestination) || _.isUndefined(mutationVariables.endDestination)}
          >{(res) => {
            if (
              res.data
              && !res.loading
              && !res.error
              && (
                mutationVariables.feeRate !== res.data.searchLastestInputFromLocation.jobInfo.feeRate
                || mutationVariables.distance !== res.data.searchLastestInputFromLocation.jobInfo.distance
              )
              && mutationVariables.isLocationChanges
            ) {
              setMutationVariables({
                ...mutationVariables,
                feeRate: res.data.searchLastestInputFromLocation.jobInfo.feeRate,
                distance: res.data.searchLastestInputFromLocation.jobInfo.distance,
              })
            }
            if (jobData?.loading && _.isEmpty(jobData?.data)) return <Loading center='true' />
            if (jobData?.error) return <P>เกิดข้อผิดพลาด</P>
            if (_.isUndefined(clientInfo.typeOfCharge)) setClientHandler({ typeOfCharge: jobData?.data?.JobInfo.Customer.TypeOfCharge.name })
            if (_.isUndefined(clientInfo.branch)) setClientHandler({ branch: jobData?.data?.JobInfo.Customer.branch })
            if (_.isUndefined(clientInfo.startDestinationText) && !_.isNull(jobData?.data?.JobInfo.startDestinationLocation)) setClientHandler({ startDestinationText: jobData?.data?.JobInfo.startDestinationLocation.branch })
            if (_.isUndefined(clientInfo.endDestinationText) && !_.isNull(jobData?.data?.JobInfo.endDestinationLocation)) setClientHandler({ endDestinationText: jobData?.data?.JobInfo.endDestinationLocation.branch })
            if (_.isUndefined(mutationVariables.availableOrder)) {
              setMutationVariables({
                ...mutationVariables, availableOrder: jobData?.data?.JobInfo.availableOrder, shippings: jobData?.data?.JobInfo.shippings.length, remainingOrder: jobData?.data?.JobInfo.availableOrder - jobData?.data?.JobInfo.shippings.length,
              })
            }
            if (_.isUndefined(mutationVariables.contractWeight)) setMutationVariables({ ...mutationVariables, contractWeight: jobData?.data?.JobInfo.contractWeight })
            if (_.isUndefined(mutationVariables.average)) setMutationVariables({ ...mutationVariables, average: jobData?.data?.JobInfo.average })
            if (_.isUndefined(mutationVariables.cargo)) setMutationVariables({ ...mutationVariables, cargo: jobData?.data?.JobInfo.cargo })
            if (_.isUndefined(mutationVariables.dealType)) setMutationVariables({ ...mutationVariables, dealType: jobData?.data?.JobInfo.dealType })
            onChangeHandler = (id, value) => {
              const parseValue = (id === 'customerId' || id === 'contractWeight')
                ? parseInt(value, 10)
                : (id === 'feeRate' || id === 'predealPrice')
                  ? parseFloat(value)
                  : value
              setMutationVariables({
                volumn: jobData?.data?.JobInfo.volumn,
                number: jobData?.data?.JobInfo.number,
                contractStart: jobData?.data?.JobInfo.contractStart,
                contractEnd: jobData?.data?.JobInfo.contractEnd,
                customerId: jobData?.data?.JobInfo.customerId,
                companyType: jobData?.data?.JobInfo.companyType,
                feeRate: !mutationVariables.feeRate && jobData?.data?.JobInfo.feeRate,
                distance: !mutationVariables.distance && jobData?.data?.JobInfo.distance,
                truckOwnerFeeRate: !mutationVariables.truckOwnerFeeRate && jobData?.data?.JobInfo.truckOwnerFeeRate,
                startDestination: !_.isNull(jobData?.data?.JobInfo.startDestinationLocation) ? jobData?.data?.JobInfo.startDestinationLocation.id : undefined,
                endDestination: !_.isNull(jobData?.data?.JobInfo.endDestinationLocation) ? jobData?.data?.JobInfo.endDestinationLocation.id : undefined,
                unit: !_.isNull(jobData?.data?.JobInfo.unit) ? jobData?.data?.JobInfo.unit : null,
                ...mutationVariables,
                [id]: parseValue,
                isLocationChanges: _.includes(['startDestination', 'endDestination'], id),
              })
            }
            return (
              <DetailContainer
                mode={{ isAddMode, isViewMode }}
                props={props}
                onChangeHandler={onChangeHandler}
                client={{ clientInfo, setClientHandler }}
                mutationVariables={mutationVariables}
                data={jobData?.data}
                loadingLastPrice={res.loading}
                dealType={dealType}
              />
            )
          }}
          </Query>
    }
    </Div>
  )
}

const DetailContainer = ({
  mode: { isAddMode, isViewMode }, data, props, onChangeHandler, client: { clientInfo, setClientHandler }, mutationVariables, loadingLastPrice, dealType,
}) => (
  <Div>
    {/* ================== Header section ================== */}
    <Div
      display='flex' flexDirection='row' alignItems='center' justifyContent={!isAddMode ? 'space-between' : 'flex-end'} padding='32px 0 40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}
    >
      {
        !isAddMode && <Div display='flex' flexDirection='column'>
          <H4 bold>Ref ID - {data.JobInfo.jobCode}</H4>
          <P bold>วันที่สร้าง - {moment(data.JobInfo.createdAt).format('DD MMMM YYYY')}</P>
        </Div>
      }
      <Div display='flex'>
        {/* <InputWithLabel
          margin='0 8px'
          width='120px'
          title={{ text: 'เล่มที่ *' }}
          input={{ disabled: isViewMode, onChange: e => onChangeHandler('volumn', e.target.value), defaultValue: _.isUndefined(data) ? null : data.JobInfo.volumn }}
        /> */}
        <Div display='flex' margin='0 8px' flexDirection='column'>
          <P margin='0 0 16px'>บริษัท *</P>
          <Select
            style={{ width: '300px' }}
            defaultValue={data?.JobInfo?.companyType}
            onChange={e => onChangeHandler('companyType', e)}
            disabled={!isAddMode}
          >
            <Select.Option value='PADOONGRICH'>บริษัท ผดุงฤทธิ์ขนส่ง จำกัด</Select.Option>
            <Select.Option value='TRANSPORT'>บริษัท ทรานสปอร์ตเตชั่น เน็ตเวิร์ค จำกัด</Select.Option>
          </Select>
        </Div>
        <InputWithLabel
          margin='0 8px'
          width='120px'
          title={{ text: 'เลขที่สัญญางาน *' }}
          input={{ disabled: isViewMode, onChange: e => onChangeHandler('number', e.target.value), defaultValue: _.isUndefined(data) ? null : data.JobInfo.number }}
        />
        <Div margin='0 8px' >
          <P margin='0 0 16px' display='block'>วันที่เริ่มอายุสัญญา *</P>
          <DatePicker
            disabled={isViewMode}
            defaultValue={isAddMode || _.isUndefined(data.JobInfo.contractStart) || _.isNull(data.JobInfo.contractStart) ? moment() : moment(data.JobInfo.contractStart, 'YYYY/MM/DD')}
            format={'YYYY/MM/DD'}
            onChange={e => onChangeHandler('contractStart', moment(e) === 'Invalid date' ? moment() : moment(e).format('YYYY-MM-DD'))}
          />
        </Div>
        <Div margin='0 8px' >
          <P margin='0 0 16px' display='block'>วันที่หมดอายุสัญญา *</P>
          <DatePicker
            disabled={isViewMode}
            defaultValue={isAddMode || _.isUndefined(data.JobInfo.contractEnd) || _.isNull(data.JobInfo.contractEnd) ? moment() : moment(data.JobInfo.contractEnd, 'YYYY/MM/DD')}
            format={'YYYY/MM/DD'}
            onChange={e => onChangeHandler('contractEnd', moment(e) === 'Invalid date' ? moment() : moment(e).format('YYYY-MM-DD'))}
          />
        </Div>
      </Div>
    </Div>
    {/* ================== Data section ================== */}
    {
      isAddMode
        ? detailType(props.match.params, onChangeHandler, { clientInfo, setClientHandler }, mutationVariables, loadingLastPrice)
        : detailType(props.match.params, onChangeHandler, { clientInfo, setClientHandler }, mutationVariables, loadingLastPrice, data.JobInfo) // argument mode
    }
    {/* ================== Data section ================== */}
    {
      // <Link to={`/shipping-order/add/${props.match.params.id}`}>
      //   <Button text='สร้างใบสั่งบรรทุก' disabled={!isViewMode} margin='32px 0' icon='far fa-shipping-fast' />
      // </Link>
      <DynamicButtonLink
        link={`/shipping-order/add/${props.match.params.id}`}
        condition={_.includes(window.perms, PERMISSION.CREATE_SHIPPING_ORDER) && isViewMode && !moment(data && data.JobInfo.contractEnd).isBefore()}
        props={{ text: moment(data && data.JobInfo.contractEnd).isBefore() ? 'สัญญาหมดอายุแล้ว' : 'สร้างใบสั่งรถบรรทุก', margin: '32px 0', icon: 'far fa-shipping-fast' }}
      />
    }
    {/* ================== Footer section ================== */}
    {
      !isViewMode
        ? <Mutation
            mutation={isAddMode ? CREATE_JOB : UPDATE_JOB}
          >{(doAction, { loading: mutationLoading }) => (
            <ActionBar
              loading={mutationLoading}
              disabled={
                // _.isUndefined(mutationVariables.volumn) || _.isEmpty(mutationVariables.volumn)
                _.isUndefined(mutationVariables.number) || _.isEmpty(mutationVariables.number)
                || _.isUndefined(mutationVariables.feeRate) || _.isNaN(mutationVariables.feeRate)
                || _.isUndefined(mutationVariables.distance) || _.isNaN(mutationVariables.distance) || Number(mutationVariables.distance) === 0
                || _.isUndefined(mutationVariables.feeRate) || _.isNaN(mutationVariables.feeRate)
                || _.isUndefined(mutationVariables.truckOwnerFeeRate) || _.isNaN(mutationVariables.truckOwnerFeeRate)
                // || mutationVariables.feeRate === 0
                || _.isUndefined(mutationVariables.contractStart) || mutationVariables.contractStart === 'Invalid date'
                || _.isUndefined(mutationVariables.unit)
                || (dealType === 'PERWEIGHT' && _.isNull(mutationVariables.unit))
                || _.isUndefined(mutationVariables.contractEnd) || mutationVariables.contractEnd === 'Invalid date'
                || _.isUndefined(mutationVariables.startDestination) || _.isUndefined(mutationVariables.endDestination)
                || _.isUndefined(mutationVariables.customerId) || _.isNaN(mutationVariables.customerId)
                || _.isUndefined(mutationVariables.companyType)
                || moment(moment(mutationVariables.contractEnd).format('YYYY-MM-DD')).isBefore(moment(mutationVariables.contractStart).format('YYYY-MM-DD'))
                || (!_.isUndefined(mutationVariables.contractWeight) && _.isNaN(mutationVariables.contractWeight))}
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              doAction={doAction}
              mutationVariables={mutationVariables}
              props={props}
            />
          )}
          </Mutation>
        : <ActionBar
            // loading={loading}
            isAddMode={isAddMode}
            isViewMode={isViewMode}
            props={props}
          />
    }
  </Div>
)

export default Index
export { Index }
